import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {ColorTypes, ControlledListItemType7} from '@Components/controlled-list/components/controlled-list-item-type-7';
import type {SocialAccountRemoveMenuProps} from './social-account-remove-menu.types';
import {SOCIAL_ACCOUNT_REMOVE_MENU_REMOVE_ITEM_ID} from './social-account-remove-menu.types';
import {clickOnKeyboardActivation} from '@Utils/dom.util';
import styles from './social-account-remove-menu.module.scss';

export function SocialAccountRemoveMenu({onRemoveAccount}: SocialAccountRemoveMenuProps): ReactElement {
  const getMenuSelector = (): ReactElement => {
    return (
      <Icon
        icon="icon-menu-dots"
        size={IconSize.SIZE_ICON_20}
        type={IconType.TRANSPARENT}
        shape={IconShape.SQUARE}
        isUsedAsButton
        role="button"
        tabIndex={0}
        onKeyDown={clickOnKeyboardActivation}
        ariaLabel={window.i18next.t('pmwjs_account_options')}
      />
    );
  };

  const getMenuPopup = (): ReactElement => {
    return (
      <ul className={styles.removeMenuList}>
        <ControlledListItemType7
          id={SOCIAL_ACCOUNT_REMOVE_MENU_REMOVE_ITEM_ID}
          className={styles.removeMenuListItem}
          text={window.i18next.t('pmwjs_remove_account')}
          textClasses="ct-neutral-primary"
          icon="icon-delete"
          color={ColorTypes.danger}
          onClick={onRemoveAccount}
        />
      </ul>
    );
  };

  return (
    <Dropdown
      className={styles.removeMenuDropdown}
      popupClassName={styles.removeMenuPopup}
      selector={getMenuSelector()}
      popup={getMenuPopup()}
      alignment={ALIGNMENT_TYPE.BOTTOM_END}
      position={DROPDOWN_POSITION.ABSOLUTE}
      selectorClassNameOnOpen="-active"
      stopClickPropagation
      doCloseOnInnerClick
      doesCloseOnOuterClick
    />
  );
}
